export default __webpack_public_path__ + "static/media/2173.cac0f2cc.png";